import { Injectable, Output, EventEmitter, Inject } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { ApiService } from '../services/api.service';
import { REST_API_REQUEST_CALL_URL } from '../utils/index';
import { FileUploader } from 'ng2-file-upload';
import { Subscription } from 'rxjs';
import { SalesManager } from './sales/model/SalesManager';
import { UserSalesMessage } from './sales.service';

@Injectable()
export class UserService {
	@Output() userListEmit: EventEmitter<Array<UserModel>> = new EventEmitter();
	// userList:Array<UserModel>;

	constructor(private http: Http, private apiService: ApiService) {
		// this.getUserList();
	};
	getNotLeaveUserList() {
		this.apiService.get(REST_API_REQUEST_CALL_URL.GET_USER_LIST).subscribe(
			resp => {
				this.userListEmit.emit(resp);
			}
		);
	}

	getUserList(type: string) {
		return this.apiService.get('user/v2/admin', { type: type });
	}

	getUserList2(page: number, size: number, callback?: (value) => void, error?: (error) => void, complete?: () => void): Subscription {
		return this.apiService.getInnerTargetApi('user', { page: page, pageSize: size }, callback, error, complete);
	}

	postUserInfo(userInfo: UserModel) {
		return this.apiService.post('user/v2/admin', userInfo);
	}

	// 사업자 등록증 확인
	getCorpReg(userId: number): Observable<any> {
		return this.apiService.get('user/v2/admin/auth/corp-reg-no', { "user-id": userId });
	}

	// 권한저장
	postUpdateCorpReg(status: string, userId: number) {
		let url;
		if (status == 'approve') {
			url = 'user/v2/admin/auth/corp-reg-file/change-approval';
		} else {
			url = 'user/v2/admin/auth/corp-reg-file/change-refuse';
		}

		return this.apiService.post(url, null, false, { "user-id": userId });
	}

	// 사업자 상태 변경
	patchUpdateStatus(userId: number, reqBody) {
		return this.apiService.patchReqDataTypeWithParams('user/v2/admin/auth/corp-reg-no', reqBody, { "user-auth-id": userId });
	}

	postCorpReg(userId: number, uploader: FileUploader) {
		uploader.setOptions({
			url: REST_API_REQUEST_CALL_URL.BASE_URL + 'admin/users/' + userId + '/corpRegFile',
			headers: [{ name: 'tx-clientid', value: 'tradlinx' }]
		});
		uploader.queue.forEach((elem) => {
			elem.alias = 'corpRegNo';
		});
		uploader.uploadAll();
	}

	getUserMemo(userId: number) {
		return this.apiService.getInnerTargetApi('usermemo', { userId: userId });
	}

	postUserMemo(userId: number, userMemo: string, callback?: (value) => void, error?: (error) => void, complete?: () => void): Subscription {
		let reqBody = { memo: userMemo, userId: userId };
		return this.apiService.postInnerTargetApi('usermemo', reqBody, callback, error, complete);
	}

	patchUserInfo(userId: number, userInfo, callback?: (value) => void, error?: (error) => void, complete?: () => void): Subscription {
		return this.apiService.patchInnerTargetApi('user/' + userId, userInfo, callback, error, complete);
	}

	patchUserAuth(userAuthId, userAuth, callback?: (value) => void, error?: (error) => void, complete?: () => void): Subscription {
		return this.apiService.patchInnerTargetApi('userauth/' + userAuthId, userAuth, callback, error, complete);
	}
}

export class CorporationInfo {
	corpId: number;
	corpRegNo: string;
	corpNm: string;
	typeCd: number;
	typeNm: string;
	ceo: string;
	establishYy: string;
	url: string;
	sales: number;
	tel: string;
	fax: string;
	address: string;
	addressDtl: string;
	zip: string;
	corpRegFile: string;
	logoFile: string;
	statusCd: number;
	statusNm: string;
}

export class TermAgreement {
	agreeYn: number = 0;
	confirmDtm: number;
	term: Term;
}

export class Term {
	htmlFileNm: string;
	mandatoryYn: number;
	noticeDtm: string;
	termId: number;
	termNm: string;
	termTp: number;
}

export class UserAuthModel {
	userAuthId: number;
	userId: number;
	authTypeCd: number;
	stusCd: number;
	key: number;
	corpRegFile: string;
	corpRegNo: string;
	remakr: string;

	constructor() {
		this.stusCd = 0;
	}
}

export class UserModel {
	userId: number;
	email: string;
	password: string;
	userTp: string;
	jobTp: string;
	jobTxt: string;
	lastNm: string;
	firstNm: string;
	address: string;
	zip: string;
	tel: string;
	mobile: string;
	fax: string;
	cntryCd: string;
	cmpnyNm: string;
	stusCd: number;
	corporation: CorporationInfo;
	termList: Array<TermAgreement>;
	regDt: number;
	updDt: number;
	userAuthList: Array<UserAuthModel>;
	salesMessages: Array<UserSalesMessage>;
	salesManager: SalesManager;
}

export class DataWithPages {
	pageNo: number;
	noOfElems: number;
	size: number;
	totalElems: number;
	totalPages: number;
	datas: Array<any>;

	constructor() {
		this.totalElems = 0;
		this.noOfElems = 0;
		this.datas = new Array();
	}
}

export class UserMemo {
	userMemoId: string;
	userId: number;
	memo: string;
	delYn: string;
	updUserId: number;
	updDtm: string;
}


// WEBPACK FOOTER //
// ./src/app/services/user.service.ts